import { render, staticRenderFns } from "./ProfessionalsStats.vue?vue&type=template&id=4626661b&"
import script from "./ProfessionalsStats.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports